/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Unit_PlaceholderInputs */

const vi_product_unit_placeholder = /** @type {(inputs: Product_Unit_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cái, kg, hộp...`)
};

/**

* @param {Product_Unit_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_unit_placeholder = /** @type {((inputs?: Product_Unit_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Unit_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_unit_placeholder(inputs)
});